import React from 'react';
import { AlertTriangleIcon, CheckIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { MAIN_MOCKUP, MOCKUP_ALT, OFFER_NAME, offerItems, pricing } from '../data/eatWellContent';
export function OfferSection() {
  return <section id="offer" className="w-full border-y border-champagne/25 bg-black py-12 sm:py-16" aria-labelledby="offer-title" data-id="element-146" data-mp="dfga53ta7wbw">
      <div className="mx-auto max-w-4xl px-5" data-id="element-147" data-mp="meab16dnb8v9">
        <div className="border border-champagne/30 bg-charcoal-950 px-5 py-6 text-center sm:px-8" data-id="element-148" data-mp="md0ewmqcsar9">
          <CountdownTimer label="Launch pricing — closes in" size="lg" data-id="element-149" data-mp="repsoa4yn2j1" />
          <p className="mt-4 flex items-center justify-center gap-2 text-[11px] font-medium uppercase tracking-[0.14em] text-rose" data-id="element-150" data-mp="wboiwhli6pby">
            <AlertTriangleIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-151" data-mp="2t7dymr8zo42i" />
            After that it increases to {pricing.afterLaunch}. It doesn’t come back.
          </p>

          <div className="mx-auto mt-6 max-w-sm" data-id="element-152" data-mp="12otg7ix4xfjj">
            <div className="flex items-baseline justify-between text-[9px] font-medium uppercase tracking-[0.16em] text-muted" data-id="element-153" data-mp="xwa5ctpu0yif">
              <span data-id="element-154" data-mp="syi8dlabym7d">Launch price spots</span>
              <span className="text-champagne" data-id="element-155" data-mp="ow3u7ehlwamf">{pricing.spotsTaken}% already taken</span>
            </div>
            <div className="mt-2 h-1 w-full overflow-hidden bg-charcoal-700" role="img" aria-label={`${pricing.spotsTaken} percent of launch-price spots already taken`} data-id="element-156" data-mp="1lm4eb07162xe">
              <div className="h-full bg-champagne" style={{
              width: `${pricing.spotsTaken}%`
            }} data-id="element-157" data-mp="1ckwpd8qemefz" />
            </div>
          </div>
        </div>

        <h2 id="offer-title" className="mt-12 text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-158" data-mp="172hhf1qqdbc">
          Choose your system
        </h2>

        <div className="mt-8 grid items-center gap-8 sm:grid-cols-2 sm:gap-10" data-id="element-159" data-mp="3tvasdysa34ak">
          <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="mx-auto w-full max-w-sm sm:max-w-none" width={1536} height={1024} data-id="element-160" data-mp="2mn9dphift66" />

          <div data-id="element-161" data-mp="3otvaugpb7fwx">
            <p className="font-display text-xl font-semibold uppercase leading-tight text-ivory-50" data-id="element-162" data-mp="3otbqyug3mhg9">
              {OFFER_NAME}
            </p>
            <p className="mt-1.5 text-[10px] font-medium uppercase tracking-[0.16em] text-muted" data-id="element-163" data-mp="3fu889rkug42a">
              Ideal for: {pricing.idealFor}
            </p>

            <ul className="mt-5 space-y-2 border-t border-charcoal-600 pt-5" data-id="element-164" data-mp="316wynv882u4t">
              {offerItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-165" data-mp="362c4q0zznlqo">
                  <CheckIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-166" data-mp="2s55s6o5uyj9w" />
                  <span className="text-[14px] leading-snug text-ivory-100" data-id="element-167" data-mp="2diqctt9yzj1a">{item}</span>
                </li>)}
            </ul>

            <p className="mt-6 text-[12px] uppercase tracking-[0.12em] text-muted line-through" data-id="element-168" data-mp="2min3u1ju0tzi">
              {pricing.regularPrice}
            </p>
            <p className="mt-1 font-display text-6xl font-semibold leading-none text-ivory-50 sm:text-7xl" data-id="element-169" data-mp="2ig8m5krwg09t">
              {pricing.today}
              <span className="ml-2 align-middle font-sans text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-170" data-mp="2wegch9ufk3c0">
                USD
              </span>
            </p>

            <div className="mt-6" data-id="element-171" data-mp="365t4q2k54vik">
              <CtaButton target="checkout" size="md" data-id="element-172" data-mp="317jd21xmkd1p" />
            </div>
            <TrustStrip className="mt-3 sm:justify-start" data-id="element-173" data-mp="319m8x2lgl0ec" />
          </div>
        </div>
      </div>
    </section>;
}